(function(){
    'use strict';

    angular.module('Directives').directive('bbaAddressDetails', bbaAddressDetails);
    bbaAddressDetails.$inject = ['$uibModal'];

    function bbaAddressDetails($uibModal){
        return {
            restirct: 'E', 
            templateUrl: '/templates/directives/components/job-details/bbaAddressDetails.html',
            scope: {
                ngModel: '=',
                type: '=',
                jobStatus: '=',
                ngDisabled: '='
            },
            link: bbaAddressDetailsLink
        }

        function bbaAddressDetailsLink(scope, elments, attrs) {
            scope.showEditAddress = showEditAddress;
            function showEditAddress(){
                const modalInstance = $uibModal.open({
                    animation: true,
                    areaLabelLeby: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/pages/jobs/add-ons/EditAddressModal.html',
                    controller: 'EditAddressModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                       addressData: function(){
                           return scope.ngModel;
                       },
                       addressType: function(){
                           return scope.type;
                       }
                    }
                });

                modalInstance.result.then(function(data){
                    scope.ngModel = data;
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/job-details/bbaAddressDetails.js